import { SetPostKyc } from './thunk/setPostKyc';
import { SetGetKyc } from './thunk/setGetKyc';

export const Thunks = {
    SetGetKyc,
    SetPostKyc
}